'use client';

import { c as _c } from "react/compiler-runtime";
import { Arrow, getClassNames } from '@sprd/sprd-component-kit/v2';
import { ReactNode } from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { AmplienceLinkType } from '@/types/amplience';
import Slider, { SliderProps } from '@/components/Slider/Slider';
import AmplienceLink from '../Common/AmplienceLink';
import VolumeDiscountProductCard, { VolumeDiscountProductItem } from './VolumeDiscountProductCard';
import { getLinePrice } from './volumeDiscountPricing';
export type VolumeDiscountProductSliderProps = {
  className?: SliderProps['className'];
  items: VolumeDiscountProductItem[];
  seeAllProductsLink: AmplienceLinkType;
  children?: ReactNode;
  selectedIndex?: number;
  quantityPerItem: number[];
  onQuantityChange: (index: number, quantity: number) => void;
  onItemSelect?: (index: number) => void;
};
export default function VolumeDiscountProductSlider(props) {
  const $ = _c(35);
  const {
    items,
    className,
    children,
    selectedIndex,
    onItemSelect,
    seeAllProductsLink,
    quantityPerItem,
    onQuantityChange
  } = props;
  const t = useTranslations("volumeDiscountCalculator");
  let slider;
  let t0;
  if ($[0] !== className || $[1] !== items || $[2] !== onItemSelect || $[3] !== onQuantityChange || $[4] !== quantityPerItem || $[5] !== seeAllProductsLink || $[6] !== selectedIndex) {
    const classNames = getClassNames(className);
    let t1;
    if ($[9] !== items || $[10] !== onItemSelect || $[11] !== onQuantityChange || $[12] !== quantityPerItem || $[13] !== selectedIndex) {
      let t2;
      if ($[15] !== onItemSelect || $[16] !== onQuantityChange || $[17] !== quantityPerItem || $[18] !== selectedIndex) {
        t2 = (item, index) => <VolumeDiscountProductCard key={index} index={index} imageBaseUrl={item.imageBaseUrl} image={item.image} price={item.price} currentDiscountAmount={getLinePrice(item, quantityPerItem[index] ?? 0).discountPercent} priceFormat={item.priceFormat} title={item.title} productTypeId={item.productTypeId} selectedIndex={selectedIndex} quantity={quantityPerItem[index] ?? 0} onItemSelect={onItemSelect} onQuantityChange={onQuantityChange} />;
        $[15] = onItemSelect;
        $[16] = onQuantityChange;
        $[17] = quantityPerItem;
        $[18] = selectedIndex;
        $[19] = t2;
      } else {
        t2 = $[19];
      }
      t1 = items.map(t2);
      $[9] = items;
      $[10] = onItemSelect;
      $[11] = onQuantityChange;
      $[12] = quantityPerItem;
      $[13] = selectedIndex;
      $[14] = t1;
    } else {
      t1 = $[14];
    }
    let t2;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex h-10 w-10 items-center justify-center rounded-full bg-black"><Arrow className="text-white" fontSize={20} /></div>;
      $[20] = t2;
    } else {
      t2 = $[20];
    }
    let t3;
    if ($[21] !== seeAllProductsLink.label) {
      t3 = <span className="text-xs">{seeAllProductsLink.label}</span>;
      $[21] = seeAllProductsLink.label;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    let t4;
    if ($[23] !== seeAllProductsLink || $[24] !== t3) {
      t4 = <AmplienceLink link={seeAllProductsLink} className="flex h-full cursor-pointer flex-col items-center justify-center gap-3 rounded border border-dashed border-neutral-200 text-sm font-semibold text-black transition-colors hover:border-black hover:bg-neutral-100 sm:justify-center">{t2}{t3}</AmplienceLink>;
      $[23] = seeAllProductsLink;
      $[24] = t3;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    slider = <Slider className={{
      ...classNames,
      slider: clsx(classNames.slider),
      item: clsx(classNames.item, "last:mr-6 md:last:mr-9"),
      root: clsx(classNames.root, "[--slides-gap:--spacing(3)] [--slides-to-show:2.4] sm:[--slides-to-show:2.2] md:[--slides-to-show:2.59]"),
      navPrev: clsx(classNames.navPrev, "!hidden bg-white text-black md:!flex lg:size-9"),
      navNext: clsx(classNames.navNext, "!hidden bg-white text-black md:!flex lg:size-9")
    }} showNavigation={true} noPadding={true}>{t1}{t4}</Slider>;
    t0 = clsx("gap-2", classNames.root);
    $[0] = className;
    $[1] = items;
    $[2] = onItemSelect;
    $[3] = onQuantityChange;
    $[4] = quantityPerItem;
    $[5] = seeAllProductsLink;
    $[6] = selectedIndex;
    $[7] = slider;
    $[8] = t0;
  } else {
    slider = $[7];
    t0 = $[8];
  }
  let t1;
  if ($[26] !== t) {
    t1 = t("sliderTitle");
    $[26] = t;
    $[27] = t1;
  } else {
    t1 = $[27];
  }
  let t2;
  if ($[28] !== t1) {
    t2 = <h3 className="font-display mb-4 text-[12px] font-black tracking-[0.1em] text-neutral-800 uppercase">{t1}</h3>;
    $[28] = t1;
    $[29] = t2;
  } else {
    t2 = $[29];
  }
  let t3;
  if ($[30] !== children || $[31] !== slider || $[32] !== t0 || $[33] !== t2) {
    t3 = <section className={t0}>{t2}{slider}{children}</section>;
    $[30] = children;
    $[31] = slider;
    $[32] = t0;
    $[33] = t2;
    $[34] = t3;
  } else {
    t3 = $[34];
  }
  return t3;
}